import { ProductCardGhost } from '@renderer-ui-library/molecules'
import { Grid } from '@renderer-ui-library/mui'
import React, { useMemo } from 'react'
import { createArrayOfLength } from '../../utils/array/createArrayOfLength'
type Props = {
  amount: number
}

export const GhostResultsList: React.FC<Props> = (props) => {
  const list = useMemo(() => createArrayOfLength(props.amount), [props.amount])
  return (
    <>
      {list.map((_, index) => (
        <Grid key={index} item xs={12} lg={4}>
          <ProductCardGhost />
        </Grid>
      ))}
    </>
  )
}
